import React from 'react';
import Spinner from '../../components/Spinner';
import config from '../../config/common';
import styles from './styles.module.scss';

const RedirectToClient = () => {
    window.location.href = `${config.client.href}${config.client.returnBackPage}`;

    return (
    <div className={styles.redirectContainer}>
      <Spinner/>
    </div>
  )
};

export default RedirectToClient;
